export const DateRenderer = ({value} = {}) => {
  return value
}
